// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__18IXC","balanceDisclaimer":"posDashboard_balanceDisclaimer__1hru3"};